<form [formGroup]="form.formGroup">
    <div class="grid">
        <div class="col">
            <div class="field">
                <label for="successiveRelationFactor">Successive Relaxation Factor (Energy Terms)</label>
                <span class="pl-1">
                    <i [pTooltip]="successiveFactorInfo" class="pi pi-info-circle"></i>
                </span>
                <app-validated-number-input
                    [id]="'successiveRelationFactor'"
                    [control]="control('successiveRelationFactor')"
                    [value]="control('successiveRelationFactor').value"
                    [validation]="{ min: 0.01, max: 2 }"
                ></app-validated-number-input>
            </div>

            <div class="field">
                <label for="latentHeatDampingFactor">Latent Heat Damping Factor (Stability)</label>

                <span class="pl-1">
                    <i [pTooltip]="latentHeatInputInfo" class="pi pi-info-circle"></i>
                </span>

                    <app-validated-number-input
                        [id]="'latentHeatDampingFactor'"
                        [control]="control('latentHeatDampingFactor')"
                        [value]="control('latentHeatDampingFactor').value"
                        [validation]="{ min: 0.01, max: 1000 }"
                    ></app-validated-number-input>
                </div>
            <div class="field flex items-center space-x-1 pt-3">
                <input
                  style="height: 13px; width: 20px;"
                  type="checkbox"
                  binary="true"
                  formControlName="includeLatentHeatPhaseChange"
                  id="phaseChange"
                >
                <label for="phaseChange">Include Latent Heat of Phase Change</label>
                
                <i [pTooltip]="latentHeatCheckboxInfo" class="pi pi-info-circle"></i>
            </div>
        </div>
    </div>
</form>